export const supabaseProjectId = "fupmdffdrqgyucuadsps"
export const supaBaseDbUrl = `https://${supabaseProjectId}.supabase.co`;

